import { useEscoposPadrao } from "./use-escopos-padrao";
import { EscoposPadraoView } from "./view-escopos-padrao";

export function EscoposPadraoScreen() {
  const vm = useEscoposPadrao();

  return <EscoposPadraoView {...vm} />;
}

export type * from "./types-escopos-padrao";
